import React from "react";

const ChevronIcon = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth={2} 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className="size-5 feather-chevron-down">
      <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

export default ChevronIcon;